/* New Comfort · productpagina 2026 — Fujiiryoki JP4000:
   galerij, subnav, maten (rechtop/languit + deur), specs en rustige scroll-animatie.
   Bewerkt op basis van nc-pdp-maesthron.js; zonder 360 en kleurschuif (geen bronbeelden). */
(function(){
  'use strict';
  var $=function(s,r){return (r||document).querySelector(s);},
      $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};

  function stickOff(){ var h=$('sticky-header')||$('.section-header'); var b=h?h.getBoundingClientRect():null; var sub=$('.ncp-sub');
    return (b&&b.bottom>0?b.bottom:0)+(sub?sub.offsetHeight:0)+8; }
  function go(id){ var t=document.getElementById(id); if(!t) return;
    window.scrollTo({top:t.getBoundingClientRect().top+window.scrollY-stickOff(),behavior:'smooth'}); }

  /* ---- 1 · galerij naar de mediakolom van main-product ---- */
  var gal=$('#ncpGal'), media=$('.product__media-wrapper');
  if(gal&&media){ media.classList.add('ncp-media'); $$(':scope > *',media).forEach(function(c){ c.style.display='none'; });
    media.insertBefore(gal,media.firstChild); gal.hidden=false; }

  /* ---- 2 · thumbs wisselen de grote foto; het 360-draaibeeld draait met slepen of pijltjes ---- */
  if(gal){
    var stage=$('#stage',gal), img=$('#stageImg',gal), bg=$('.gal__bg',gal);
    var press=function(t){ $$('.thumb',gal).forEach(function(x){ x.setAttribute('aria-pressed', x===t?'true':'false'); }); };

    /* 360-draaibeeld: acht opnamen (basis + hoek + .jpg), slepen of met de pijltjes */
    var t360=$('.thumb[data-360]',gal), hoeken=[], frames=[], stand=0, geladen=false,
        deg=$('#galDeg',gal), ticks=$$('.gal__ticks i',gal);
    if(t360){
      hoeken=t360.getAttribute('data-360').split(',');
      var basis=t360.getAttribute('data-360base');
      frames=hoeken.map(function(h){ return basis+h+'.jpg?width=1100'; });
      stand=0;
    }
    var toon=function(i){
      if(!frames.length) return;
      stand=((i%frames.length)+frames.length)%frames.length;
      img.src=frames[stand];
      if(deg) deg.value=hoeken[stand].replace(/^0+(?=\d)/,'')+'\u00B0';
      ticks.forEach(function(t,k){ t.classList.toggle('on',k===stand); });
    };
    var open360=function(){
      press(t360);
      stage.classList.remove('is-photo'); stage.classList.add('is-360');
      if(bg) bg.style.backgroundImage='';
      if(!geladen){ geladen=true; frames.forEach(function(u){ var i=new Image(); i.src=u; }); }
      toon(stand);
    };

    $$('.thumb',gal).forEach(function(t){
      t.addEventListener('click',function(){
        if(t===t360){ open360(); return; }
        press(t);
        stage.classList.remove('is-360'); stage.classList.add('is-photo');
        var src=t.getAttribute('data-full');
        img.src=src; if(bg) bg.style.backgroundImage='url("'+src+'")';
      });
    });

    $$('.gal__deg button',gal).forEach(function(b){
      b.addEventListener('click',function(){ toon(stand + (+b.getAttribute('data-spin'))); });
    });

    /* kleurkeuze in het koopblok (Shopify variant-picker) wisselt de grote foto naar die kleur */
    document.addEventListener('change',function(e){
      var v=e.target && e.target.value; if(!v) return;
      var t=$$('.thumb[data-variant]',gal).filter(function(x){ return x.getAttribute('data-variant').toLowerCase()===String(v).toLowerCase(); })[0];
      if(t) t.click();
    });

    if(t360 && window.PointerEvent){
      var sleept=false, vorigeX=0, opgespaard=0, STAP=26;
      stage.addEventListener('pointerdown',function(e){
        if(!stage.classList.contains('is-360')) return;
        sleept=true; vorigeX=e.clientX; opgespaard=0;
        try{ stage.setPointerCapture(e.pointerId); }catch(err){}
      });
      stage.addEventListener('pointermove',function(e){
        if(!sleept) return;
        opgespaard += e.clientX-vorigeX; vorigeX=e.clientX;
        while(Math.abs(opgespaard)>=STAP){
          var richting = opgespaard>0 ? 1 : -1;
          toon(stand-richting); opgespaard -= richting*STAP;
        }
      });
      ['pointerup','pointercancel','pointerleave'].forEach(function(n){
        stage.addEventListener(n,function(){ sleept=false; });
      });
    }
  }

  /* ---- 3 · subnav scrollt naar de sectie ---- */
  $$('[data-jump]').forEach(function(a){
    a.addEventListener('click',function(e){
      var id=a.getAttribute('data-jump'); if(!document.getElementById(id)) return;
      e.preventDefault(); go(id);
    });
  });

  /* ---- 4 · past hij? — maten in cm (rechtop = diepte, languit = lengte; breedte 85 cm) ---- */
  var LEN_UP=141, LEN_FLAT=212, W=85, DOOR=70;
  var room=$('#room'), wide=$('#wide'), door=$('#door');
  if(room&&wide&&door){
    var plek=function(){
      var r=+room.value||0, w=+wide.value||0, out=[];
      if(r>=LEN_FLAT) out.push(['','Ook languit past hij: dan is hij '+LEN_FLAT+' cm.']);
      else if(r>=LEN_UP) out.push(['no','Rechtop past hij ('+LEN_UP+' cm); languit vraagt '+LEN_FLAT+' cm.']);
      else out.push(['no','Te krap: rechtop '+LEN_UP+' cm, languit '+LEN_FLAT+' cm.']);
      out.push(w>=W+10 ? ['','Breedte: '+W+' cm, je hebt ruimte aan de zijkanten.'] : ['no','Breedte: '+W+' cm; laat aan de zijkanten minimaal 5 cm over.']);
      $('#verdPlek').innerHTML=out.map(function(o){ return '<li class="'+o[0]+'">'+o[1]+'</li>'; }).join('');
    };
    var deur=function(){ var d=+door.value||0;
      $('#verdDoor').innerHTML = d>=DOOR
        ? '<li>Past door een deur van '+d+' cm.</li>'
        : '<li class="no">'+d+' cm is smaller dan de minimale '+DOOR+' cm. Bel ons — vaak halen we hem ter plekke uit elkaar.</li>'; };
    room.addEventListener('input',plek); wide.addEventListener('input',plek); door.addEventListener('input',deur);
    plek(); deur();
  }

  /* ---- 5 · specs uitklappen ---- */
  var sb=$('#specBtn');
  if(sb) sb.addEventListener('click',function(){
    var g=$('#specgrid'), on=g.classList.toggle('all');
    sb.setAttribute('aria-expanded',on); sb.textContent=on?'Toon minder':'Toon alle kenmerken';
  });

  /* ---- 6 · rustige scroll-animatie (stijl wordt hier ingevoegd, niet in het CSS-bestand) ---- */
  var zacht = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if(zacht && 'IntersectionObserver' in window){
    var st=document.createElement('style');
    st.textContent='.ncp .nc-rise{opacity:0;transform:translateY(18px);transition:opacity .62s cubic-bezier(.22,.61,.36,1),transform .62s cubic-bezier(.22,.61,.36,1)}.ncp .nc-rise.is-in{opacity:1;transform:none}';
    document.head.appendChild(st);
    var rise=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(!e.isIntersecting) return;
        e.target.classList.add('is-in'); rise.unobserve(e.target); });
    },{threshold:.12, rootMargin:'0px 0px -6% 0px'});
    [
      {els:$$('#massage .rv > *'), kolommen:2, stap:120},
      {els:$$('#functies .fgg'), kolommen:2, stap:120},
      {els:$$('#functies .fx figure'), kolommen:2, stap:120},
      {els:$$('#functies .fstrip img'), kolommen:4, stap:80},
      {els:$$('#past .dfig'), kolommen:1, stap:0}
    ].forEach(function(g){
      g.els.forEach(function(el,i){
        el.classList.add('nc-rise');
        el.style.transitionDelay=((i % g.kolommen)*g.stap)+'ms';
        rise.observe(el);
      });
    });
  }
})();
